import { render } from "./ReseauLayout.vue?vue&type=template&id=66965810"
import script from "./ReseauLayout.vue?vue&type=script&lang=js"
export * from "./ReseauLayout.vue?vue&type=script&lang=js"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142212-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__